import React, { useEffect, useState } from "react";
import { SlDrawer, SlIcon } from "@shoelace-style/shoelace/dist/react";
import { useForm } from "react-hook-form";
import { Toast } from "../../shared/Toast";
import API from "../../services/api";
import { useSelector } from "react-redux";
function Interaction(props) {
  const [pocContacts, setPocContacts] = useState([]);
  const editData = props.editData;
  const today = new Date().toISOString().split("T")[0];
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({ mode: "onTouched" });
  const fetchPoc = async () => {
    try {
      let res = await API({
        url: "/accountManagement/get_all_poc",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: props.brand.brand_id,
        },
      });
      if (res.code === 200) {
        setPocContacts(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchPoc();
  }, []);
  useEffect(() => {
    if (props.edit) {
      setValue("interaction_type", `${editData.type}`);
      setValue("poc_person", editData.poc_id);
      setValue("description", editData.description);
      setValue("status", `${editData.status}`);
      setValue("campaign_outlay", editData.campaign_outlay);
    }
  }, [props.edit]);
  const onSubmit = async (data) => {
    if (props.edit) {
      try {
        let res = await API({
          url: "/accountManagement/edit_interaction",
          method: "POST",
          responseType: "json",
          data: {
            brand_id: props.brand.brand_id,
            interaction_date: editData.interacted_date,
            interaction_type: data.interaction_type,
            poc_id: data.poc_person,
            description: data.description,
            status: data.status,
            campaign_outlay: data.campaign_outlay,
            id: editData.id,
          },
        });
        if (res.code === 200) {
          Toast("success", "Interaction edited successfully");
          props.setShow(false);
          props.loadData();
        } else {
          Toast("error", res.data?.message || res.message);
        }
      } catch (error) {
        console.error(error, "Error in editing Interaction");
      }
    }
    else{
      try {
        let res = await API({
          url: "/accountManagement/add_interaction",
          method: "POST",
          responseType: "json",
          data: {
            brand_id: props.brand.brand_id,
            interaction_date: today,
            interaction_type: data.interaction_type,
            poc_id: data.poc_person,
            description: data.description,
            status: data.status,
            campaign_outlay: data.campaign_outlay,
            // sales_head:data.sales_head ? data.sales_head : undefined,
          },
        });
  
        if (res.code === 200) {
          Toast("success", "Interaction added successfully");
          props.setShow(false);
          props.loadData();
        } else {
          Toast("error", res.data?.message || res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
    
  };
  return (
    <>
      <SlDrawer
        label="POC"
        open={props.show}
        onSlRequestClose={handleRequestClose}
        noHeader={true}
        // contained={true}
        // style={{ "--size": "32vw" }}
      >
        <div className="px-2 pt-2 relative">
          <h3 className="my-0">Record Interaction</h3>
          <p className="text-gray-500 text-xs my-0">
            {props.brand?.brand_name}
          </p>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-3">
              <label className="form-label mb-2">Interaction type</label>

              <div className="d-flex gap-2.5 flex-wrap">
                <div class="custom-radio">
                  <input
                    type="radio"
                    id="ide1"
                    value={1}
                    {...register("interaction_type", { required: true })}
                  />
                  <label for="ide1" className="rounded-full">
                    <SlIcon name="person-check"></SlIcon>
                    <span>Direct Meeting</span>
                  </label>
                </div>
                <div class="custom-radio">
                  <input
                    type="radio"
                    id="ide2"
                    value={2}
                    {...register("interaction_type", { required: true })}
                  />
                  <label for="ide2" className="rounded-full">
                    <SlIcon name="laptop" library="lucide"></SlIcon>
                    <span>Virtual Meeting</span>
                  </label>
                </div>
                <div class="custom-radio">
                  <input
                    type="radio"
                    id="ide3"
                    value={3}
                    {...register("interaction_type", { required: true })}
                  />
                  <label for="ide3" className="rounded-full">
                    <SlIcon name="phone" library="lucide"></SlIcon>
                    <span>Call</span>
                  </label>
                </div>
                <div class="custom-radio">
                  <input
                    type="radio"
                    id="ide4"
                    value={4}
                    {...register("interaction_type", { required: true })}
                  />
                  <label for="ide4" className="rounded-full">
                    <SlIcon name="whatsapp"></SlIcon>
                    <span>Whatsapp</span>
                  </label>
                </div>
                <div class="custom-radio">
                  <input
                    type="radio"
                    id="ide5"
                    value={5}
                    {...register("interaction_type", { required: true })}
                  />
                  <label for="ide5" className="rounded-full">
                    <SlIcon name="envelope"></SlIcon>
                    <span>Email</span>
                  </label>
                </div>
              </div>
              {errors.interaction_type && (
                <p className="text-red-600">Please choose Interaction type</p>
              )}
            </div>
            {/* <div className="mb-3">
              <label className="form-label">Interaction Date</label>
              <input type="date" className="form-control" {...register('interaction_date', {required:true,max:{value:today, message:"Date cannot be in future"}})} />
              {errors.interaction_date && <p className="text-red-600">{errors.interaction_date?.message || 'Please choose Interaction Date'}</p>}
            </div> */}
            <div className="mb-3">
              <label className="form-label">With whom</label>
              <select
                className="form-select"
                placeholder="Select POC"
                {...register("poc_person", { required: true })}
              >
                <option value="" disabled selected hidden>
                  Please Choose...
                </option>
                {pocContacts.map((person) => {
                  return <option value={person.value}>{person.label}</option>;
                })}
              </select>
              {errors.poc_person && (
                <p className="text-red-600">Please choose POC</p>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">Description</label>
              <textarea
                className="form-control"
                rows={3}
                {...register("description", { required: true })}
                placeholder="Enter Description here"
              ></textarea>
              {errors.description && (
                <p className="text-red-600">Please Enter Description</p>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">
                Way2news Campaign Visibility Status
              </label>
              <div>
                <div className="d-flex">
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={1}
                      {...register("status", { required: true })}
                      id="flexRadioDefault1"
                    />
                    <label class="form-check-label" for="flexRadioDefault1">
                      in 1 week
                    </label>
                  </div>
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={2}
                      {...register("status", { required: true })}
                      id="flexRadioDefault2"
                    />
                    <label class="form-check-label" for="flexRadioDefault2">
                      in 2 weeks
                    </label>
                  </div>
                </div>
                <div className="d-flex">
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={3}
                      {...register("status", { required: true })}
                      id="flexRadioDefault3"
                    />
                    <label class="form-check-label" for="flexRadioDefault3">
                      in 3 weeks
                    </label>
                  </div>
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={4}
                      {...register("status", { required: true })}
                      id="flexRadioDefault4"
                    />
                    <label class="form-check-label" for="flexRadioDefault4">
                      Later next month
                    </label>
                  </div>
                </div>
                <div className="d-flex ">
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={5}
                      {...register("status", { required: true })}
                      id="flexRadioDefault5"
                    />
                    <label class="form-check-label" for="flexRadioDefault5">
                      After 2 months
                    </label>
                  </div>
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={6}
                      {...register("status", { required: true })}
                      id="flexRadioDefault6"
                    />
                    <label class="form-check-label" for="flexRadioDefault6">
                      Campaign Received
                    </label>
                  </div>
                </div>
                <div className="d-flex">
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={7}
                      {...register("status", { required: true })}
                      id="flexRadioDefault7"
                    />
                    <label class="form-check-label" for="flexRadioDefault7">
                      Not Interested
                    </label>
                  </div>
                  <div class="form-check w-1/2 text-xs text-gray-700">
                    <input
                      class="form-check-input"
                      type="radio"
                      value={8}
                      {...register("status", { required: true })}
                      id="flexRadioDefault8"
                    />
                    <label class="form-check-label" for="flexRadioDefault8">
                      No Visibility yet
                    </label>
                  </div>
                </div>
              </div>
              {errors.status && (
                <p className="text-red-600">Please choose status!</p>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">Possible Campaign Outlay</label>
              <input
                className="form-control"
                type="number"
                placeholder="Enter Campaign Outlay"
                {...register("campaign_outlay", { required: true, min: 0 })}
              />

              {errors.campaign_outlay && (
                <p className="text-red-600">Please enter Campaign Outlay</p>
              )}
            </div>
            {/* <div className="mb-3">
              <label className="form-label">Sales Head</label>
              <select className="form-select" placeholder="Select POC" {...register('sales_head', {required:false})}>
              <option value="" disabled selected hidden>Please Choose...</option>
                {salesUsersList.map((person)=>{
                  return(<option value={person.value}>{person.label}</option>)
                })}
              </select>
              {errors.sales_head && <p className="text-red-600">Please choose Sales Head</p>}
            </div> */}
            <div>
              <button
                className="w-100 bg-[#0079BC] px-4 py-3 text-white font-bold   text-xs rounded "
                type="submit"
               disabled={isSubmitting}
              >
                {isSubmitting ? "Saving" : "Save Details"}
              </button>
            </div>
          </form>
          <SlIcon
            className="absolute top-3 right-6 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => props.setShow(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </>
  );
}

export default Interaction;
